import React from "react";
import { Tooltip } from "./Tooltip";

interface ScoreProps {
  score: number;
  className?: string;
}

export const Score: React.FC<ScoreProps> = ({ score, className = "" }) => {
  // Convert decimal score to percentage
  const percentage = Math.round(score * 100);

  // Determine color based on score range
  const getBackgroundColor = () => {
    if (percentage >= 80) return "#17A34A";
    if (percentage >= 50) return "#E5A73C";
    return "#FFA500";
  };

  return (
    <Tooltip
      content="This score indicates how well the property matches your search criteria. Higher score means a better match."
      placement="top"
    >
      <div
        className="inline-flex items-center justify-center py-0.5 rounded-full cursor-help ring-4 ring-white/50 px-3"
        style={{ backgroundColor: getBackgroundColor() }}
        aria-label={`Match score: ${percentage}%`}
      >
        <span className="text-[13px] tracking-wider font-semibold text-white">
          {percentage}% Match
        </span>
      </div>
    </Tooltip>
  );
};
